import useSWR, { SWRConfiguration } from 'swr';

const fetcher = async (url: string) => {
  const r = await fetch(url);
  if (!r.ok) throw Object.assign(new Error('API_ERROR'), { status: r.status, body: await r.json().catch(() => null) });
  return r.json();
};

export interface KpiSummaryResponse {
  success: boolean;
  data: {
    totalRevenue: number;
    revenueTrend: number;
    collectionRate: number;
    collectionTrend: number;
    avgCollectionDays: number;
    collectionDaysTrend: number;
    outstandingAmount: number;
    outstandingTrend: number;
  };
}

export interface ProjectPipelineItem {
  projectId: string;
  projectNo: string;
  name: string;
  orderedBy: string;
  arStatus: string;
  contractAmount: number;
  paidAmount: number;
  receivable: number;
  progressPct: number;
  pmName: string | null;
  dueAt: string | null;
}

export interface ProjectPipelineResponse {
  success: boolean;
  data: {
    items: ProjectPipelineItem[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      hasMore: boolean;
    };
  };
}

export function useProjects(params: Record<string, string | undefined>, opt?: SWRConfiguration) {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null) as any).toString();
  return useSWR<ProjectPipelineResponse>(`/api/pay-agent/projects?${qs}`, fetcher, { keepPreviousData: true, ...opt });
}

export const useProject = (id: string | null) =>
  useSWR(id ? `/api/pay-agent/projects/${id}` : null, fetcher);

export const useKpi      = () => useSWR<KpiSummaryResponse>('/api/pay-agent/aggregations/kpi', fetcher);
export const useAging    = () => useSWR('/api/pay-agent/aggregations/aging', fetcher);
export const useByVendor = () => useSWR('/api/pay-agent/aggregations/by-vendor', fetcher);
export const useByYear   = () => useSWR('/api/pay-agent/aggregations/by-year', fetcher);

export async function changeStatus(projectId: string, to: string, note?: string) {
  const r = await fetch(`/api/pay-agent/projects/${projectId}/status`, {
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ to, note }),
  });
  if (!r.ok) throw await r.json();
  return r.json();
}
